import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content" }

import ChatInputBar from "@/components/Dialogues/Chat/ChatInputBar.vue";
import ChatSlogan from "@/components/Dialogues/Chat/ChatSlogan.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ChatCover',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ChatSlogan),
    _createVNode(ChatInputBar)
  ]))
}
}

})